module.exports = __webpack_public_path__ + "img/DiscordV2-Normal.39318869.webp";